import React, { useEffect, useState } from "react";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { useCookies } from "react-cookie";
import ReactPlayer from "react-player";
import { useParams } from "react-router-dom";
import { getSignedUrl } from "ServerAPI/serverAPI";
import AudiotrackIcon from "@mui/icons-material/Audiotrack";
import audioTrack from "../../../../assets/images/course/audio-track.gif";

const AudioPlayer = ({ activeContent, fileName }) => {
  const { courseId, sectionId } = useParams();
  const [cookies] = useCookies();
  const [audioUrl, setAudioUrl] = useState("");
  const [audioLoading, setAudioLoading] = useState(false);

  const getAudioUrl = async () => {
    setAudioLoading(true);
    const payload = {
      courseId: courseId,
      sectionId: sectionId,
      fileName: fileName,
      method: "GET",
      userId: cookies?.userId,
    };
    try {
      const response = await getSignedUrl(payload);
      const generatedUrl = response.data.preSignedUrl;
      setAudioUrl(response?.data?.preSignedUrl);
      setAudioLoading(false);
    } catch (error) {
      console.error("Error fetching the video URL:", error);
    }
  };
  useEffect(() => {
    getAudioUrl();
  }, [courseId, sectionId, fileName]);
  return (
    <>
      <section className="mt-6 course-container">
        <Container fluid>
          <Row>
            <Col sm={12} md={12} lg={12}>
              <div className="content">
                <div>
                  {audioLoading ? (
                    <div className="d-flex justify-content-center align-items-center w-100 h-100 course-container">
                      <Spinner />
                    </div>
                  ) : (
                    <div
                      style={{
                        borderRadius: "15px",
                        overflow: "hidden",

                        height: "80vh",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div style={{ height: "80%" }}>
                        <img src={audioTrack} alt="audio track" width="100%" />
                      </div>
                      <div>
                        {/* <ReactPlayer
                          url={audioUrl}
                          playing
                          controls
                          height="50px"
                          width="100%"
                        
                        /> */}
                        <audio
                          controls
                          controlsList="nodownload"
                          onContextMenu={(e) => e.preventDefault()}
                          style={{ width: "100%" }}
                          autoPlay={true}
                        >
                          <source src={audioUrl} />
                        </audio>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AudioPlayer;
